export type IntercomMode = "" | "av" | "audio" | "none";

export interface PeerView {
  sessionId: string;
  state: RTCPeerConnectionState | "new";
  stream: MediaStream | null;
  hasVideo: boolean;
  hasAudio: boolean;
  speaking: boolean;
}

/** Intercom UI state. Media objects are held here as raw refs; components render from them. */
class IntercomStore {
  mode = $state<IntercomMode>("");
  muted = $state(false);
  opening = $state(false);
  error = $state("");
  localStream = $state.raw<MediaStream | null>(null);
  peers = $state<Record<string, PeerView>>({});
  /** Debug override of the received quality (null = server-derived). */
  debugQuality = $state<number | null>(null);

  setPeer(id: string, patch: Partial<PeerView>) {
    const cur = this.peers[id] ?? { sessionId: id, state: "new", stream: null, hasVideo: false, hasAudio: false, speaking: false };
    this.peers = { ...this.peers, [id]: { ...cur, ...patch } };
  }
  removePeer(id: string) {
    const { [id]: _gone, ...rest } = this.peers;
    this.peers = rest;
  }
  reset() { this.mode = ""; this.muted = false; this.localStream = null; this.peers = {}; this.error = ""; }
}

export const intercom = new IntercomStore();
